// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"9148abd0","111":"8b6b5b63","170":"bd5a0219","253":"92ef205f","363":"bd5a0219","526":"d30ee3a3","707":"bd5a0219"}[chunkId] + ".chunk.css";
};